import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, WorkOrderService } from "../../../services/index";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./actualWorkReturn.html",
})
export class actualWorkreturnComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  // groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    wo_no: "",
    order_from_date: "",
    order_to_date: "",
    wo_from_date: "",
    wo_to_date: "",
    wo_ret_id: "",
    finyear: "2019-2020",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  approvedList = ["Approved", "Not Approved", "All"];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  showApprove: boolean = false;
  showColumns: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private woservice: WorkOrderService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns(this.showColumns);
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns(showColumns) {
    this.showColumns = showColumns;
    if (!this.showColumns) {
      this.filter.wo_ret_id = "";
      this.finyearCombo();
    } else {
      // this.getActaulworkorderlist();
      this.pageCallback({ offset: 0 });
    }

    if (this.filter.wo_ret_id !== "") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },

        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },

        {
          name: "Shade",
          prop: "shade",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },

        {
          name: "Color",
          prop: "color",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Ret.Mtr",
          prop: "mtr",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
      ];
    } else {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Ref No",
          prop: "ref_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },

        {
          name: "Sample No",
          prop: "sample_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },

        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    }
    this.toggleCol = Object.assign({}, this.columns);
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
  finyearCombo() {
    // if(this.filter.wo_ret_id !==""){
    //   this.filter.wo_ret_id ="";
    // }
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.pageCallback({ offset: 0 });
    });
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getActaulworkorderlist();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.wo_no = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    //  this.filter.wo_from_date = '';
    //   this.filter.wo_to_date = "";

    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getActaulworkorderlist();
  }
  gobacktoGroup() {
    this.showApprove = false;
    this.filter.wo_ret_id = "";
    this.showColumns = true;
    this.getColumns(this.showColumns);
    // this.getColumns();
  }
  // loadSeasonList() {
  //   let that = this;
  //   this.combo2Service.seasonCombo().then(function(res) {
  //     //  this.LoadAgentList();
  //     that.seasonList = res.data;
  //     that.seasonCtrl.setValue(res.data[0].season_id);
  //   });
  // }

  viewReturndetails(row) {
    this.filter.wo_ret_id = row.wo_ret_id;
    this.showColumns = true;
    this.getColumns(this.showColumns);
    // this.getActaulworkorderlist();
  }
  gotoApprove(row) {
    this.showApprove = true;
    this.filter.wo_ret_id = row.wo_ret_id;
    // this.getActaulworkorderlist();
    this.showColumns = true;
    this.getColumns(this.showColumns);
  }
  addApprovestatus() {
    let that = this;
    that.showColumns = false;
    let params = {
      approval: "Approved",
      wo_ret_id: this.filter.wo_ret_id,
    };

    swal({
      title: "Are you sure to Approve?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes,Save it!",
      cancelButtonText: "No, keep it",
    }).then(function () {
      that.isLoadMask = that.woservice
        .addApprovestatus(params)
        .then(function (res: any) {
          that.loadingIndicator = false;
          that.getColumns(that.showColumns);
          let errtype = "success";
          // errmsg = res.message;
          if (!res.success) {
            errtype = "error";
          }
        });
    });
  }

  getActaulworkorderlist(): void {
    if (this.filter.wo_from_date !== "") {
      this.filter.wo_from_date = this.datePipe.transform(
        this.filter.wo_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.wo_to_date !== "") {
      this.filter.wo_to_date = this.datePipe.transform(
        this.filter.wo_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wo_no: this.filter.wo_no,
      wo_from_date: this.filter.wo_from_date,
      wo_to_date: this.filter.wo_to_date,
      wo_ret_id: this.filter.wo_ret_id,
      finyear: this.filter.finyear,
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getActaulworkorderlist(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/actualWorkReturn.ts